import CryptoJS from 'crypto-js';
const ENCRYPTION_KEY = process.env.ENCRYPTION_KEY;

const EncryptionService = {
  sha256: (payload) => {
    return CryptoJS.SHA256(payload).toString();
  },
  encrypt: (payload) => {
    const key = CryptoJS.enc.Hex.parse(ENCRYPTION_KEY);
    const ivWordArray = CryptoJS.lib.WordArray.random(16);

    let ciphertext = CryptoJS.AES.encrypt(payload, key, {
      iv: ivWordArray,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    });
    const cipherPayload = `${ivWordArray.toString()}.${ciphertext}`;
    const base64Payload = btoa(cipherPayload);
    return base64Payload;
  },
  decrypt: (base64Payload) => {
    const cipherPayload = atob(base64Payload);
    const [iv, ciphertext] = cipherPayload.split('.');
    const key = CryptoJS.enc.Hex.parse(ENCRYPTION_KEY);
    const ivWordArray = CryptoJS.enc.Hex.parse(iv);

    const decrypted = CryptoJS.AES.decrypt(ciphertext, key, {
      iv: ivWordArray,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
};
export default EncryptionService;